import React, { useEffect, useState } from 'react';
import { useData } from '../context/DataContext';
import { Table, Button } from 'react-bootstrap';
import TablePaginationBar from '../components/TablePaginationBar';
import { BsThreeDots } from 'react-icons/bs';
import useFetchData from '../hooks/useFetchData';
import { config } from '../config/config';
import { getcancelledappointments } from '../config/url';
import formatDate from '../utils/formatDate';

const CancelledAppointments = () => {
  const [render, setRender] = useState(null);
  const [currentAppointments, setCurrentAppointments] = useState(null);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('');
  const [filteredAppointments, setFilteredAppointments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [appointmentsPerPage] = useState(7);

  const appointments = useFetchData(getcancelledappointments, config);

  useEffect(() => {
    if (appointments) {
      let filtered = appointments;

      if (filter === 'Sort by Date') {
        filtered = appointments.sort((a, b) => {
          const dateA = new Date(a.creationDate);
          const dateB = new Date(b.creationDate);
          return dateA - dateB;
        });
      }

      if (search) {
        filtered = filtered.filter((appointment) =>
          Object.values(appointment)
            .join(' ')
            .toLowerCase()
            .includes(search.toLowerCase())
        );
      }

      setFilteredAppointments(filtered);
      setRender(Math.floor(Math.random() * 10));
    }
  }, [search, filter, appointments]);

  useEffect(() => {
    const indexOfLastAppointment = currentPage * appointmentsPerPage;
    const indexOfFirstAppointment =
      indexOfLastAppointment - appointmentsPerPage;
    setCurrentAppointments(
      filteredAppointments.slice(
        indexOfFirstAppointment,
        indexOfLastAppointment
      )
    );
  }, [render]);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className='p-2'>
      <h2>Cancelled Appointments</h2>
      {appointments != null ? (
        <div className='d-flex justify-content-end mb-3'>
          <div className='me-2'>
            <input
              type='text'
              className='form-control rounded'
              placeholder='Search by session ID, user, provider...'
              style={{ maxWidth: '300px' }}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <div>
            <select
              className='form-select'
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            >
              <option value=''>Select Filter</option>
              <option value='Sort by Date'>Sort by Date</option>
            </select>
          </div>
        </div>
      ) : null}
      <div className='bg-white my-4 rounded shadow'>
        {appointments != null ? (
          <Table responsive='xl' striped bordered hover>
            <thead>
              <tr>
                <th>Date</th>
                <th>User</th>
                <th>Provider</th>
                <th>Reason</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentAppointments.map((appointment) => (
                <tr key={appointment._id}>
                  <td>{formatDate(appointment.appointmentDate)}</td>
                  <td>
                    {appointment.user.firstName}
                    {' ' + appointment.user.lastName}
                  </td>
                  <td>
                    {appointment.specialistId.firstName}
                    {' ' + appointment.specialistId.lastName}
                  </td>
                  <td>{appointment.reason}</td>
                  <td>
                    <Button variant='secondary' size='md'>
                      <BsThreeDots />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <h4 className='h4 mt-4 mb-4'>Fetching data...</h4>
        )}
      </div>
      <TablePaginationBar
        currentPage={currentPage}
        totalItems={filteredAppointments.length}
        rowsPerPage={appointmentsPerPage}
        onPageChange={paginate}
      />
    </div>
  );
};

export default CancelledAppointments;
